export const orderConstants = {
  GETALL_REQUEST: "ORDERS_GETALL_REQUEST",
  GETALL_SUCCESS: "ORDERS_GETALL_SUCCESS",
  GETALL_FAILURE: "ORDERS_GETALL_FAILURE",

  GET_REQUEST: "ORDERS_GET_REQUEST",
  GET_SUCCESS: "ORDERS_GET_SUCCESS",
  GET_FAILURE: "ORDERS_GET_FAILURE",

  GET_PAYMENTS_REQUEST: "ORDERS_GET_PAYMENTS_REQUEST",
  GET_PAYMENTS_SUCCESS: "ORDERS_GET_PAYMENTS_SUCCESS",
  GET_PAYMENTS_FAILURE: "ORDERS_GET_PAYMENTS_FAILURE",

  UPDATE_REQUEST: "ORDERS_UPDATE_REQUEST",
  UPDATE_SUCCESS: "ORDERS_UPDATE_SUCCESS",
  UPDATE_FAILURE: "ORDERS_UPDATE_FAILURE",
};
